import { Modal } from "./Modal.js";
import { DialogActions } from "../molecules/DialogActions.js";

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ title, message, confirmLabel, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <Modal onClose={onCancel} ariaLabel={title}>
      <h2>{title}</h2>
      <p style={{ color: "var(--mmm-muted)", margin: 0 }}>{message}</p>
      <DialogActions
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmType="button"
        confirmLabel={confirmLabel}
        confirmVariant="danger"
      />
    </Modal>
  );
}
